export default __webpack_public_path__ + "static/media/viwangosaccos.e07c01b0.png";